// extracted by mini-css-extract-plugin
export default {"root":"styles_root__7qriz","container":"styles_container__73dlh"};